const apiBaseUrl = 'https://api.sancristobal.com.ar/';

export const environment = {
    production: true,
    name: 'prodcentralus',
    hotJarSiteId: 768119,
    server: {
        web: {
            home: 'https://productores.sancristobal.com.ar/',
            poliza: 'https://productores-poliza.sancristobal.com.ar/',
            dynamo: 'https://portalpas.sancristobal.com.ar',
            dynamoFaq: 'https://soportepas.sancristobal.com.ar/',
            legacy: 'https://pas.sancristobal.com.ar/',
            combinedFamily: 'https://hogar.sancristobal.com.ar',
            marketing: 'https://productores.sancristobal.com.ar/'
        },
        api: {
            baseUrl: apiBaseUrl,
            auth: apiBaseUrl + 'authapi',
            contactManager: apiBaseUrl + 'portalpas-contactmanager',
            typeList: apiBaseUrl + 'portalpas-typelist',
            car: apiBaseUrl + 'portalpas-commercialauto',
            utility: apiBaseUrl + 'utility',
            legacy: apiBaseUrl + 'portalpas-legacy/api',
            crossSelling: apiBaseUrl + 'portalpas/api',
            cS: apiBaseUrl + 'portalpas-cs/api',
            claim: apiBaseUrl + 'siniestros-claim/api',
            marketing: apiBaseUrl + 'marketing-marketing/api',
            dynamo: apiBaseUrl + 'portalpas-dynamo/api',
            combinedFamily: apiBaseUrl + 'portalpas-combinedfamily/api',
            combinedIntegralTrade: apiBaseUrl + 'portalpas-combinedintegraltrade/api',
            policy: apiBaseUrl + 'portalpas-policy/api',
            ca7claim: apiBaseUrl + 'siniestros-ca7claim/api',
            claimoorrapi: apiBaseUrl + 'siniestros-claimoorr/api',
            ca7lite: apiBaseUrl + 'portalpas-ca7lite/api',
            ca7PortalPas: apiBaseUrl + 'portalpas-ca7/api',
            notification: apiBaseUrl + 'siniestros-notification/api',
            thirdpartyclaim: apiBaseUrl + 'reclamosterceros-thirdpartyclaim/api',
            ap: apiBaseUrl + 'portalpas-personalaccidents/api',
            policySearch: apiBaseUrl + 'portalpas-search/api',
            policyDetail: apiBaseUrl + 'portalpas-policyinfo/api',
            portalpas: apiBaseUrl + 'portalpas/api',
            portalpasProxy: apiBaseUrl + 'portalpas',
            location: apiBaseUrl + 'location/api',
        }
    },
    imageHosting: {
        account: 'productoresimages',
        container: 'productores-files-dev',
    },
    invision: {
        dsmSCSS: 'https://sancristobal.invisionapp.com/dsm-export/san-cristobal-seguros/dsm-sc/_style-params.scss?key=rylDXvBtf',
        dsmIMGs: 'https://sancristobal.invisionapp.com/dsm-export/san-cristobal-seguros/dsm-sc/icons.zip?key=rylDXvBtf'
    },
    appInsightsKey: '8bee5c86-0b8e-40e6-ab3a-ee457952b05c',
    google: {
        GA: {
            token: 'UA-114949103-1'
        },
        GTM: {
            token: 'GTM-KJPCHDH'
        }
    },
    marketingDigital: {
        imagesResources: 'https://marketingdigitalprod.blob.core.windows.net/'
    }
};
